import cn from "classnames";
import styles from "./CustomCheckbox.module.scss";

interface CustomCheckboxProps {
  checked: boolean;
  onChange?: () => void;
  disabled?: boolean;
  className?: string;
}

const CustomCheckbox: RFC<CustomCheckboxProps> = ({ checked, onChange, disabled, className }) => {
  return (
    <div
      className={cn(styles.checkboxContainer, styles.checkboxContainer, { [styles.disabled]: disabled }, className)}
      onClick={onChange}
    >
      <div className={cn(styles.checkbox, { [styles.checked]: checked })}>
        <div className={styles.checkmark}></div>
      </div>
    </div>
  );
};

export default CustomCheckbox;
